export const FETCH_USERS_START = 'FETCH_USERS_START';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAIL = 'FETCH_USERS_FAIL';

export type UserActionTypes = typeof FETCH_USERS_START | typeof FETCH_USERS_SUCCESS | typeof FETCH_USERS_FAIL;
